import React, { Component } from 'react';
import styles from './AideAdmin.module.scss';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
// import Bouton from "../../composant/UI/Bouton/Bouton";
//
// import * as actions from "../../store/actions";
// import {connect} from "react-redux";
import { IoMdHelpCircle } from 'react-icons/io';
import { RiVideoFill } from 'react-icons/ri';
import { GrDocumentPdf } from 'react-icons/gr';
import { checkMot } from '../../ressources/functionJS/checkMot';
import { RiFolderOpenFill } from 'react-icons/ri';
import { RiLineChartFill } from 'react-icons/ri';
import { GiMovementSensor } from 'react-icons/gi';
import { RiTreasureMapFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
class AideAdmin extends Component {
  state = {};

  render() {
    return (
      <div className={[styles.container, styles.molder].join(' ')}>
        <div className={styles.title}>
          <IoMdHelpCircle size={49} color={'#EEB214'} /> {checkMot('aide')}
          <Link to={url.Formation}>
            <div className={styles.bts}>
              <span className={styles.Span}>/</span>

              {checkMot('client')}
            </div>
          </Link>
        </div>

        <div className={[styles.img].join(' ')}>
          <h4 className={styles.subtitle}>
            {checkMot('bienvenue_dans_argos_v19')}
          </h4>
          <p className={styles.Parag}>
            {checkMot(
              "Nous sommes ravis de vous compter parmi nous ! consulte le guide l'essentiel pour avoir une vue d'ensemble de tous les aspects de ArgosV19. Consultez des vidéos pour obtenir d'autres informations."
            )}
          </p>
        </div>
        {/* <div className={[s.order_sm_3, styles.intro].join(" ")}>
          <h4 className={styles.subtitle}>{checkMot("formation")}</h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={"#a6163f"} />
            </div>
            <a
              onClick={() =>
                window.open(
                  "/videos/demo.MP4",
                  "_blank",
                  "toolbar=0,location=0,menubar=0"
                )
              }
              className={styles.lien}
            >
              {checkMot("regardez_la_video")}{" "}
            </a>
          </div>
        </div> */}
        <div className={[s.order_sm_3, styles.bloc].join(' ')}>
          <h4 className={styles.subtitle}>
            <RiFolderOpenFill size={40} color={'#EEB214'} />{' '}
            {checkMot("Démarrage rapide : L'essentiel")}
          </h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} color={'#a6163f'} />
            </div>
            <button
              type="button"
              onClick={() => {
                window.open(
                  '/pdf/start.pdf',
                  '_blank',
                  'toolbar=0,location=0,menubar=0, width=1200, height=750'
                );
              }}
              className={styles.lien}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
              }}
            >
              {checkMot("Guide l'essentiel")}{' '}
            </button>
          </div>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a
              href="/pdf/Creationdeprojet.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.open('pdf/Creationdeprojet.pdf')}
              className={styles.lien}
            >
              {checkMot('creation_de_projet')}{' '}
            </a>
          </div>
          {/* <div className={styles.Parag}>
              <div className={styles.icon}>
                <GrDocumentPdf size={20} />
              </div>
              <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
                {checkMot("modifier_un_projet")}
              </a>
            </div> */}
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {" "}
              {checkMot("Niveau d'accès de un projet")}{" "}
            </a>
          </div> */}
        </div>
        <div className={[s.order_sm_3, styles.bloc].join(' ')}>
          <h4 className={styles.subtitle}>
            <GiMovementSensor size={40} color={'#EEB214'} />{' '}
            {checkMot('capteurs')}
          </h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={'#a6163f'} />
            </div>
            <button
              type="button"
              onClick={() =>
                window.open(
                  '/videos/Capteur.mp4',
                  '_blank',
                  'toolbar=0,location=0,menubar=0'
                )
              }
              className={styles.lien}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                textAlign: 'left',
                font: 'inherit',
              }}
            >
              {' '}
              {checkMot('configuration_des_capteurs')}
            </button>
          </div>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a
              href="pdf/CreationdeCapteurs.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.open('pdf/CreationdeCapteurs.pdf')}
              className={styles.lien}
            >
              {checkMot('creation_de_capteurs')}{' '}
            </a>
          </div>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a
              href="pdf/Creationtypedecapteur.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.open('pdf/Creationtypedecapteur.pdf')}
              className={styles.lien}
            >
              {checkMot('creation_type_de_capteur')}{' '}
            </a>
          </div>
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {" "}
              {checkMot("Sous-conposante de capteur")}{" "}
            </a>
          </div> */}
        </div>
        <div className={[s.order_sm_3, styles.bloc].join(' ')}>
          <h4 className={styles.subtitle}>
            <RiLineChartFill size={40} color={'#EEB214'} />{' '}
            {checkMot('graphes')}
          </h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={'#a6163f'} />
            </div>
            <button
              type="button"
              className={styles.lien}
              onClick={() =>
                window.open(
                  '/videos/graphe_demo.mp4',
                  '_blank',
                  'toolbar=0,location=0,menubar=0, width=1200, height=750'
                )
              }
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                textAlign: 'left',
                font: 'inherit',
              }}
            >
              {' '}
              {checkMot('affichage_des_graphes')}
            </button>
          </div>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a
              href="pdf/Creationdesgraphes.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.open('pdf/Creationdesgraphes.pdf')}
              className={styles.lien}
            >
              {checkMot('creation_de_graphe')}{' '}
            </a>
          </div>
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("modifier_un_graphe")}{" "}
            </a>
          </div> */}
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("graphes_personnaliser")}{" "}
            </a>
          </div> */}
        </div>
        <div className={[s.order_sm_3, styles.bloc].join(' ')}>
          <h4 className={styles.subtitle}>
            <RiTreasureMapFill size={40} color={'#EEB214'} /> {checkMot('vues')}
          </h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={'#a6163f'} />
            </div>
            <button
              type="button"
              className={styles.lien}
              onClick={() =>
                window.open(
                  '/videos/vues_demo.mp4',
                  '_blank',
                  'toolbar=0,location=0,menubar=0,width=1000, height=750'
                )
              }
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                textAlign: 'left',
                font: 'inherit',
              }}
            >
              {' '}
              {checkMot('Affichages : Tableaux de bord et Plans')}
            </button>
          </div>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a
              href="pdf/Creationdesvues.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.open('pdf/Creationdesvues.pdf')}
              className={styles.lien}
            >
              {checkMot('creation_des_vue')}{' '}
            </a>
          </div>
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/Création des vues.pdf")} className={styles.lien}>
              {checkMot("modifier_un_vue")}{" "}
            </a>
          </div> */}
          {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("vues_personnaliser")}{" "}
            </a>
          </div> */}
        </div>
        {/* <div className={[s.order_sm_3, styles.bloc].join(" ")}>
          <h4 className={styles.subtitle}>
            <FaUsers size={40} color={"#EEB214"} /> {checkMot("utilisateurs")}
          </h4>
          <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={"#a6163f"} />
            </div>
            <a
              className={styles.lien}
              onClick={() =>
                window.open(
                  "/videos/demo.MP4",
                  "_blank",
                  "toolbar=0,location=0,menubar=0"
                )
              }
            >
              {" "}
              {checkMot("configurer_et_personnaliser_des_utilisateurs")}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("creation_de_utilisateur")}{" "}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("modifiers_un_utilisateur")}{" "}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("Niveau d'accès de un Utilisateur")}{" "}
            </a>
          </div> */}
        {/* </div> */}
        {/* <div className={[s.order_sm_3, styles.bloc].join(" ")}>
          <h4 className={styles.subtitle}>
            <MdNotificationsActive size={40} color={"#EEB214"} />{" "}
            {checkMot("alarme")}
          </h4> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <RiVideoFill size={40} color={"#a6163f"} />
            </div>
            <a
              className={styles.lien}
              onClick={() =>
                window.open(
                  "/videos/demo.MP4",
                  "_blank",
                  "toolbar=0,location=0,menubar=0"
                )
              }
            >
              {" "}
              {checkMot("configurer_et_personnaliser_des_alarmes")}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("creation_de_alarme")}{" "}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("modifier_un_alarme")}{" "}
            </a>
          </div> */}
        {/* <div className={styles.Parag}>
            <div className={styles.icon}>
              <GrDocumentPdf size={20} />
            </div>
            <a onClick={() => window.open("pdf/demo.pdf")} className={styles.lien}>
              {checkMot("alarme_personnaliser")}{" "}
            </a>
          </div> */}
        {/* </div> */}
      </div>
    );
  }
}

export default AideAdmin;
